import api, { request } from '../../api';
import { IStore } from '..';

const actions = {
  getClubInvitations: async (state: IStore, clubId: number | string) => {
    const response = await request.get(`${api.admin.clubInvitations(clubId)}`);

    if (response.error) {
      return {
        errors: { ...state.errors, clubInvitations: { msg: 'Error checking the invitation code' } }
      };
    }

    return { clubInvitations: { invitations: response } };
  }
};

export default actions;
